module.exports = __webpack_public_path__ + "img/icon_on.405271d.png";